import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/** Rôle `CLIENT_LECTURE` : portail client. Sinon : back-office interne. */
const CLIENT_ROLE = 'CLIENT_LECTURE';

/**
 * LOT B3 — accueil authentifié : ROUTE selon le rôle. Un client (lecture seule) atterrit sur son
 * portail ; les utilisateurs internes gardent le back-office. Rendu sous `ProtectedRoute` (l'identité
 * est donc déjà chargée).
 */
export function HomeRedirect(): JSX.Element {
  const { user } = useAuth();
  const isClient = user?.roles.includes(CLIENT_ROLE) ?? false;
  return <Navigate to={isClient ? '/portail' : '/dashboard'} replace />;
}
